import { createElement } from 'react';
import { Global, css } from '@emotion/core';
import { grey } from '@material-ui/core/colors';

const GlobalStyles = () => (
  <Global
    styles={css`
      * {
        margin: 0;
        box-sizing: border-box;
      }
      html,
      body {
        width: 100%;
        height: auto;
        line-height: 1;
        background-color: ${grey[50]};
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 0;
      }
      #app {
        width: 100%;
        height: 100%;
      }
    `}
  />
);

export default GlobalStyles;
